const getDefaultClue = () => {
  return {
    details: [{
        type: 'introduction',
      },
      {
        type: 'hard',
      },
      // {
      //   type: 'easy',
      // },
      {
        type: 'hint',
      },
      // {
      //   type: 'dropOff',
      // },
    ]
  };
};

// FIXME: ONLY FOR TEST WILL BE REPLACED BY API
const getClueTypes = () => {
  return [{
    name: 'Please Select',
    value: 0,
  }, {
    name: 'Riddle',
    value: 1,
  }, {
    name: 'Pizzle',
    value: 2,
  }, {
    name: 'Code',
    value: 3,
  }];
};

const getClueObjFromAPI = (clueFromAPI) => {
  let c = getDefaultClue();
  c.id = clueFromAPI.id;
  c.providerId = clueFromAPI.providerId;
  c.type = clueFromAPI.type;
  c.details = clueFromAPI.details;
  return c;
}

export {
  getDefaultClue,
  getClueTypes,
  getClueObjFromAPI,
};
